export default __webpack_public_path__ + "static/lady_justice-f0675537ccf5e2dcf88790248d346f1e.png";